<template>
  <AppModal
    v-model="showEnergyModal"
    @on-close="props.onClose"
    dialog-titel="Produktinformationsblad (EU)"
  >
    <section class="h-[70dvh] m-16">
      <slot />
    </section>
  </AppModal>
</template>
<script setup lang="ts">
interface Props {
  showEnergyModalProp: boolean;
  onClose: () => void;
}

const props = defineProps<Props>();

const showEnergyModal: Ref<boolean> = ref(false);

watch(
  () => props.showEnergyModalProp,
  () => {
    showEnergyModal.value = props.showEnergyModalProp;
  },
);
</script>
